import { FromPriceDisplay } from '../PriceDisplay';
import { TextButton } from '../TextButton';
import {
  ActionButton,
  ActionButtonIcon,
  ActionButtonLabel,
  CardWrapper,
  Label,
  LeftContent,
  Name,
  PriceWrapper,
  RightSection,
  TextContent,
  Thumbnail,
  ThumbnailImage,
  ThumbnailPlaceholder,
  UnavailableDivider,
  UnavailableText,
  UnavailableTextWrapper,
} from './ListItemCard.styles';
import { CARD_IMAGE_SIZING } from '../EntityImage';
import { PlusIcon } from '../../icons/PlusIcon';
import type { ListItemCardProps } from './ListItemCard.types';

export function ListItemCard({
  name,
  label,
  image,
  price,
  buttonLabel = 'Select',
  onSelect,
  unavailable,
  unavailableLabel = 'Unavailable',
  editSearchLabel = 'Edit search',
  onEditSearch,
}: ListItemCardProps) {
  return (
    <CardWrapper $unavailable={unavailable} data-testid="list-item-card">
      <LeftContent>
        <Thumbnail>
          {image?.src ? (
            <ThumbnailImage src={image.src} alt={image.alt ?? name} sizing={CARD_IMAGE_SIZING} />
          ) : (
            <ThumbnailPlaceholder data-testid="thumbnail-placeholder" />
          )}
        </Thumbnail>
        <TextContent>
          <Name>{name}</Name>
          {label && <Label>{label}</Label>}
        </TextContent>
      </LeftContent>

      <RightSection>
        {unavailable ? (
          <UnavailableTextWrapper>
            <UnavailableText>{unavailableLabel}</UnavailableText>
            {onEditSearch && (
              <>
                <UnavailableDivider aria-hidden />
                <TextButton onClick={onEditSearch}>{editSearchLabel}</TextButton>
              </>
            )}
          </UnavailableTextWrapper>
        ) : (
          price && (
            <PriceWrapper>
              <FromPriceDisplay
                amount={price.amount}
                currencyCode={price.currencyCode}
                label={price.label}
                discount={price.discount}
                locale={price.locale}
                size="base"
              />
            </PriceWrapper>
          )
        )}
        {onSelect && (
          <ActionButton onClick={onSelect} aria-label={buttonLabel}>
            <ActionButtonLabel>{buttonLabel}</ActionButtonLabel>
            <ActionButtonIcon aria-hidden>
              <PlusIcon size={24} />
            </ActionButtonIcon>
          </ActionButton>
        )}
      </RightSection>
    </CardWrapper>
  );
}
